import { Component, OnInit, Input } from '@angular/core';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';
import { UserRepoService } from '@client/app/services/api/user-repo/user-repo.service';
import { UserToOutputModel } from '@client/app/forms/domain/steps/users/user-to-output.model';

@Component({
    selector: 'form-domain-users',
    templateUrl: './form-domain-users.component.html',
    standalone: false,
})
export class FormDomainUsersComponent extends BaseContainerComponentController implements OnInit {
    @Input() domain!: any;
    users: any[] = [];
    progress: any;

    updatedUsers: UserToOutputModel[] = [];

    constructor (
        private userRepoService: UserRepoService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.activate();
    }

    private activate () {
        if (!this.domain) {
            return;
        }
        this.domain.domain_users = this.domain.domain_users || [];
        this.getPage();
    }

    override getPage () {
        this.progress = this.userRepoService
            .getAll({ page_size: this.pageSize, page: this.page })
            .then((users: any) => {
                this.users = users;
                this.addKnownDomainUsers(users);

                const updatedUsers = this.copyCollection(this.users);

                for (let i = 0; i < updatedUsers.length; i += 1) {
                    const userToOutput = new UserToOutputModel(updatedUsers[i]);
                    userToOutput.name = userToOutput.getName();
                    userToOutput.isVisible = this.isVisible(userToOutput);
                    userToOutput.hasSendReport = this.hasSendReport(userToOutput);
                    updatedUsers[i] = userToOutput;
                }

                this.updatedUsers = this.copyCollection(updatedUsers);
            });
    }

    private copyCollection (collection: any, start = 0, end?): any[] {
        const newCollection: any = collection.slice(start, end);
        newCollection.total = collection.total || 0;
        newCollection.perPage = collection.perPage;
        newCollection.currentPage = collection.currentPage;
        return newCollection;
    }

    private addKnownDomainUsers (users: any[]) {
        this.domain.domain_users.forEach((domainUser: any) => {
            const userExists = users.some(user => user.id === domainUser.user_id);
            if (!userExists && domainUser.user) {
                users.push(domainUser.user);
            }
        });

        users.forEach(user => {
            const index = this.domain.domain_users.findIndex((domainUser) => {
                return domainUser.user_id === user.id;
            });

            if (index === -1) {
                this.setDomainUser(user);
            }
        });
    }

    setDomainUser (user) {
        this.domain.domain_users.push({
            user_id: user.id,
            visible: Boolean(user.customer_admin),
            send_report: false,
        });
    }

    private isVisible (user: UserToOutputModel): boolean {
        const domainUser = this.domain.domain_users.find((du: any) => du.user_id === user.id);
        return domainUser ? domainUser.visible : false;
    }

    private hasSendReport (user: UserToOutputModel): boolean {
        const domainUser = this.domain.domain_users.find((du: any) => du.user_id === user.id);
        return domainUser ? domainUser.send_report : false;
    }

    private getDomainUserId (user: UserToOutputModel): number {
        return this.domain.domain_users.findIndex((du: any) => du.user_id === user.id);
    }

    toggleVisible (user: UserToOutputModel, userOutputIndex: number) {
        const index = this.getDomainUserId(user);
        if (index === -1) {
            return;
        }

        user.isVisible = !user.isVisible;
        const domainUser = this.domain.domain_users[index];
        domainUser.visible = !domainUser.visible;
        if (!user.isVisible) {
            user.hasSendReport = false;
            domainUser.send_report = false;
        }
        this.updatedUsers[userOutputIndex].isVisible = user.isVisible;
    }

    toggleSendReport (user: UserToOutputModel, userOutputIndex: number) {
        const index = this.getDomainUserId(user);
        if (index === -1) {
            return;
        }

        user.hasSendReport = !user.hasSendReport;
        this.domain.domain_users[index].send_report = !this.domain.domain_users[index].send_report;
        this.updatedUsers[userOutputIndex].hasSendReport = user.hasSendReport;
    }

    trackByUserId (index: number, user: UserToOutputModel): number {
        return user.id;
    }
}
